module.exports = __webpack_public_path__ + "static/media/Guido Marsan  (3).18df7eac.jpg";